<template>
  <div>
    <template v-for="(item,i) in titles">
      <title-block :key="i" :id="'bm'+item.label" v-if="item.num && activeInfo">
        <template slot="title">{{item.label}}</template>
        <div class="mt-10">
          <el-table :data="tableDatas(item.moduleId)" :header-cell-style="{background: '#fafafa',color: '#333'}" tooltip-effect="light">
            <template v-for="(item1, j) in tableFields(item.moduleId)">
              <el-table-column v-if="item1.field != 'rk'" :key="j" :label="item1.fieldName" align="center" show-overflow-tooltip>
                <template slot-scope="scope">
                  <!-- {{whichType(scope.row[j])}} -->
                  <span v-if="whichType(scope.row[j])==='string'">{{columnValue(scope.row[j], item.moduleId)}}</span>
                  <span v-else-if="whichType(scope.row[j])==='array'" v-html="columnValue(arrParse(scope.row[j]), item.moduleId)"></span>
                  <span v-else-if="whichType(scope.row[j])==='object'">{{columnValue(scope.row[j], item.moduleId)}}</span>
                  <span v-else>--</span>
                </template>
              </el-table-column>
            </template>
          </el-table>
          <pagination :pageNum="tablePage(item.moduleId)" :total="tableTotal(item.moduleId)" @currentChange="val => handleCurrentChange(val, i)" />
        </div>
      </title-block>
    </template>
  </div>
</template>


<script>
import mixin from '../mixins/enterpriseTabs'
export default {
  mixins: [mixin],
  name: 'legalRisk',
  data() {
    return {
      name: this.$route.query.name,
      titles: [
        { type: '', label: '失信信息', num: 0, moduleId: '' },
        { type: '', label: '裁判文书', num: 0, moduleId: '' },
        { type: '', label: '开庭公告', num: 0, moduleId: '' },
        { type: '', label: '立案信息', num: 0, moduleId: '' },
        { type: '', label: '法院公告', num: 0, moduleId: '' },
        { type: '', label: '执行信息', num: 0, moduleId: '' },
        { type: '', label: '股权冻结', num: 0, moduleId: '' },
        { type: '', label: '限制消费令', num: 0, moduleId: '' },
        { type: '', label: '终本案件', num: 0, moduleId: '' },
      ],
    }
  },

  mounted() {

  },

  methods: {
    arrParse(str) {
      let arr = JSON.parse(this.strTranslation(str))
      let htmlstr = ''
      for (let i = 0; i < arr.length; i++) {
        htmlstr += `<div class="textOverflow"><span>${arr[i].role}：</span><span>${arr[i].name}</span></div>`
      }
      return htmlstr
    },
  }
}
</script>
<style lang='scss' scoped>
/deep/ .el-table th > .cell {
  font-size: 12px;
  font-weight: 400;
}
/deep/ .el-table th {
  padding: 10px 0;
  line-height: 16px;
}
/deep/ .el-table .cell {
  font-size: 12px;
  font-weight: 400;
  span {
    font-size: 12px;
  }
}
</style>
